<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    <div v-if="showAlert" class="alert alert-danger alert-dismissible">
      <button
        type="button"
        class="close"
        aria-hidden="true"
        @click="closeAlert"
      >
        ×
      </button>
      <h4><i class="icon fa fa-ban"></i> Error!</h4>
      {{ errMessage }}
    </div>
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEditBrand)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Brand Name"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="brand">
                Brand Name <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="brand"
                class="form-control"
                v-model="brandName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Brand Name"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
          
                </ValidationProvider>
          </div>
  <!--
          <div class="col-sm-6">
            <div class="form-group">
              <label
                >Image (100x100) <span class="required-color">*</span></label
              >
              <input
                type="file"
                name="category_image"
                class="form-control"
                v-on:change="onFileChanged"
              />

              <img
                :src="fileContent"
                id="img_edit"
                style="height: 80; width: 70px;border:1px solid #CCCCCC;"
              />
            </div>
          
          </div>
           <ValidationProvider name="Sort Order" rules="required" v-slot="{ errors }">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="sort_order">Sort Order</label>
              <input
                type="text"
                name="sort_order"
                v-model="sort_order"
                autocomplete="off"
                data-parsley-trigger="keyup"
                data-parsley-type="number"
                class="form-control"
                id="sort_order"
                value=""
                placeholder="Sort Order"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
          
          </div>
           </ValidationProvider>
            <ValidationProvider name="Color Code" rules="required" v-slot="{ errors }">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="sort_order">Color Code</label>
              <input
                type="text"
                name="color_code"
                v-model="color_code"
                autocomplete="off"
                data-parsley-trigger="keyup"
                class="form-control"
                value=""
                placeholder="Color Code"
              />
               <span style="color:red">{{ errors[0] }}</span>
            </div>
           
          </div>
       </ValidationProvider>
          -->
          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-brand')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";

export default {
  props: ["brandId"],
  name: "AddBrand",
  data() {
    return {
      saveCat: false,
      parent_id: "0",
      brand_id: '',
      brandList: [],
      errors : [],
      brandName: "",
      color_code: "",
      sort_order: "",
      category_image: "",
      baseUrl: this.$store.state.baseURL,
      showCatDropdown: false,
      selectedImage: null,
      loading: false,
    };
  },
  components: {},
  methods: {
    addEditBrand() {
       this.loading = false
      this.saveCat = true;
      // this.category_image = this.fileContent;
      this.brand_id = this.$props.brandId;
      this.errors = []
      if (!this.brandName) {
        this.errors.push("Brand Name required.");
      }
      /*
      if (!this.color_code) {
        this.errors.push("Color Code required.");
      }
      if (!this.category_image) {
        this.errors.push("Category Image is required.");
      }
      if (!this.sort_order) {
        this.errors.push( "Sort Order required.");
      }
      */
      if(!this.errors.length){
      const addBrand = {
        "brand-form": {
          brand_id: this.brand_id,
          brand_name: this.brandName
          /*,
          sort_order: this.sort_order,
          color_code: this.color_code,
          category_image: this.category_image,*/
        },
      };
      if (this.brand_id > 0) {
        api
          .request("post", "GeneralApis/edit_brand", addBrand)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-brand");
              this.$emit("list-brands");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_brand", addBrand)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-brand");
              this.$emit("list-brands");
            }
          });
      }
      }
    },
    getBrand: function() {
      var brandid = this.$props.brandId;
      (this.brandList = []),
        (this.brandName = ""),/*
        (this.sort_order = ""),
        (this.color_code = ""),
        (this.fileContent = ""),*/
        (this.brand_id = 0);
      if (brandid > 0) {
        this.brand_id = brandid;

        const getbrands = {
          filter: {
            brand_id: this.brand_id,
          },
        };
        api
          .request("post", "GeneralApis/get_brands", getbrands)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.brandList = data.brandList[0];
              this.brandName = this.brandList.brand_name;/*
              this.sort_order = this.catlist.sort_order;
              this.color_code = this.catlist.color_code;
              this.fileContent = this.baseUrl + this.catlist.category_image;*/
            }
          });
      }
    },
  },
  mounted() {
    this.getBrand();
  },
};
</script>
